import * as React from "react";
import { VideoPagesList } from "@/containers/VideoPages";
import { SuperPageTabsPage, SuperPageCreateForm, SuperPagesList } from "@/containers/SuperPages";

type Props = {
  tab?: string;
  id?: string;
};

const VideoPagesTab: React.FC<Props> = ({ tab, id }) => {
  if (tab === "super-pages") {
    if (id === "new") {
      return <SuperPageCreateForm />;
    } else if (isFinite(Number(id))) {
      return <SuperPageTabsPage superPageId={Number(id)} />;
    } else {
      return <SuperPagesList />;
    }
  }
  return <VideoPagesList />;
};

export default VideoPagesTab;
